import React from 'react'
import { Text } from '@shared/ui/atoms'

export const newAccountInstructionSteps = [
  {
    content: (
      <Text family="MTSCompact" size={{ desktop: 'pL', mobile: 'pM' }} weight="medium" color="primary">
        Войди в&nbsp;свой аккаунт Steam на&nbsp;сайте или в&nbsp;приложении на&nbsp;смартфоне. Не&nbsp;используй
        изменение своего сетевого расположения&nbsp;&mdash; иначе домашний регион аккаунта сменится
      </Text>
    ),
  },
  {
    content: (
      <Text family="MTSCompact" size={{ desktop: 'pL', mobile: 'pM' }} weight="medium" color="primary">
        Добавь на&nbsp;аккаунт минимум две бесплатные игры. Например, PUBG и&nbsp;Dota 2. Можно добавлять игры через
        библиотеку Steam в&nbsp;приложении на&nbsp;смартфоне
      </Text>
    ),
  },
  {
    content: (
      <Text family="MTSCompact" size={{ desktop: 'pL', mobile: 'pM' }} weight="medium" color="primary">
        Играй не&nbsp;менее 5 часов в&nbsp;добавленных играх
      </Text>
    ),
  },
  {
    content: (
      <Text family="MTSCompact" size={{ desktop: 'pL', mobile: 'pM' }} weight="medium" color="primary">
        Пополни аккаунт на&nbsp;минимальную сумму&nbsp;&mdash; 350 &#8381;
      </Text>
    ),
  },
]
